export default __webpack_public_path__ + "static/media/289.83bedbc7.jpg";